const apiurl="https://4d2zdyit63.execute-api.us-east-1.amazonaws.com/prod/";

export default apiurl;
